import { useEffect, useState } from 'react';

import useLanguage from '@hooks/useLanguage';
import { createClient } from '@spazious/client-booking-engine';
import { createClientMock } from '@spazious/client-booking-engine/mock';
import { BookingEngineProvider, BookingEngineProviderProps } from '@spazious/react-booking-engine';

const basePath = import.meta.env.SPZ_API_BASE_URL || new URL(window.location.href).origin;

export const defaultApiClient = createClient({
  basePath,
});

export const apiClientMock = createClientMock({
  basePath: 'https://localhost:3000',
});

export interface AppDynamicClientProps {
  children?: React.ReactNode;
  apiClient?: BookingEngineProviderProps['client'];
  mocks?: boolean;
}

/**
 * This component dynamically loads the client configuration
 * base on the user preferences and other app setting.
 */
export const AppDynamicClient: React.FC<AppDynamicClientProps> = ({
  children,
  mocks = false,
  apiClient: apiClientProp = mocks ? apiClientMock : defaultApiClient,
}) => {
  const { locale } = useLanguage();

  const [apiClient, setApiClient] = useState(apiClientProp);

  useEffect(() => {
    setApiClient(
      mocks
        ? apiClientMock
        : createClient({
            basePath,
            headers: {
              'Accept-Language': locale,
            },
          })
    );
  }, [locale, mocks]);

  return <BookingEngineProvider client={apiClient}>{children}</BookingEngineProvider>;
};

export default AppDynamicClient;
